import { call, put, takeLatest } from "redux-saga/effects";
import { apiCall } from '../config/axios';
import {
  START_GET_LEARNING_ROUTE,
  SUCCESS_GET_LEARNING_ROUTE,
  ERROR_GET_LEARNING_ROUTE,
  START_CREATE_LEARNING_ROUTE,
  SUCCESS_CREATE_LEARNING_ROUTE,
  ERROR_CREATE_LEARNING_ROUTE,
  START_EDIT_LEARNING_ROUTE,
  SUCCESS_EDIT_LEARNING_ROUTE,
  ERROR_EDIT_LEARNING_ROUTE,
  START_DELETE_LEARNING_ROUTE,
  SUCCESS_DELETE_LEARNING_ROUTE,
  ERROR_DELETE_LEARNING_ROUTE,
  START_GET_LEARNING_ROUTE_BY_ID,
  SUCCESS_GET_LEARNING_ROUTE_BY_ID,
  ERROR_GET_LEARNING_ROUTE_BY_ID,
} from "../types";

function* getLearningRoutes() {
  try {
    const response = yield call(apiCall, 'get', '/learning-paths');
    if (response.data.error) throw new Error(response.data.msg);

    yield put({ type: SUCCESS_GET_LEARNING_ROUTE, payload: response.data });
  } catch (error) {
    yield put({ type: ERROR_GET_LEARNING_ROUTE, payload: error.message });
  }
}

function* createLearningRoute({ payload }) {
  try {
    const response = yield call(apiCall, 'post', '/learning-paths', payload);
    if (response.data.error) throw new Error(response.data.msg);

    yield put({ type: SUCCESS_CREATE_LEARNING_ROUTE, payload: response.data });
  } catch (error) {
    yield put({ type: ERROR_CREATE_LEARNING_ROUTE, payload: error.message });
  }
}

function* editLearningRoute({ payload }) {
  try {
    const { id, name, description, courseIds, level, order, status } = payload;
    const body = { name, description, courseIds, level, order, status };

    const response = yield call(apiCall, 'put', `/learning-paths/${id}`, body);

    yield put({ type: SUCCESS_EDIT_LEARNING_ROUTE, payload: response.data });
  } catch (error) {
    yield put({ type: ERROR_EDIT_LEARNING_ROUTE, payload: error.message });
  }
}


function* deleteLearningRouteSaga(action) {
  try {
    const id = action.payload;
    yield call(apiCall, "delete", `/learning-paths/${id}`);
    yield put({ type: SUCCESS_DELETE_LEARNING_ROUTE, payload: id });
  } catch (error) {
    yield put({ type: ERROR_DELETE_LEARNING_ROUTE, payload: error.message });
  }
}


function* fetchLearningRouteById(action) {
  try {
    const response = yield call(apiCall, 'get', `/learning-paths/${action.payload}`);
    if (response.data.error) throw new Error(response.data.msg);

    yield put({ type: SUCCESS_GET_LEARNING_ROUTE_BY_ID, payload: response.data });
  } catch (error) {
    yield put({ type: ERROR_GET_LEARNING_ROUTE_BY_ID, payload: error.message });
  }
}

export function* learningRoutes() {
  yield takeLatest(START_GET_LEARNING_ROUTE, getLearningRoutes);
  yield takeLatest(START_CREATE_LEARNING_ROUTE, createLearningRoute);
  yield takeLatest(START_EDIT_LEARNING_ROUTE, editLearningRoute);
  yield takeLatest(START_DELETE_LEARNING_ROUTE, deleteLearningRouteSaga);
  yield takeLatest(START_GET_LEARNING_ROUTE_BY_ID, fetchLearningRouteById);
}
